var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.896,
    height: 37.896,
    viewBox: "0 0 37.896 37.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47854",
    "data-name": "Group 47854",
    transform: "translate(-186 -704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47913",
    "data-name": "Group 47913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47853",
    "data-name": "Group 47853",
    transform: "translate(196.658 713.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93723",
    "data-name": "Path 93723",
    d: "M32.211,25.12v8.091H20.368V21.368h8.806A28.973,28.973,0,0,1,31.473,19h-11.1A2.368,2.368,0,0,0,18,21.368V33.211a2.368,2.368,0,0,0,2.368,2.368H32.211a2.368,2.368,0,0,0,2.368-2.368V22.569a24.93,24.93,0,0,0-2.368,2.551",
    transform: "translate(-18 -17.224)",
    fill: "#b077d8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93722",
    "data-name": "Path 93722",
    d: "M38.641,16a1.184,1.184,0,0,0-.642.189A28.854,28.854,0,0,0,28.937,26.22l-2.479-3.242a1.184,1.184,0,0,0-1.882,1.439L28.2,29.154a1.184,1.184,0,0,0,2.027-.248,27.42,27.42,0,0,1,9.059-10.727A1.185,1.185,0,0,0,38.641,16",
    transform: "translate(-20.583 -16)",
    fill: "#b077d8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_93724",
    "data-name": "Path 93724",
    d: "M29.361,11.653A27.42,27.42,0,0,0,20.3,22.38a1.184,1.184,0,0,1-2.027.248l-3.623-4.737a1.184,1.184,0,0,1,1.882-1.439l2.479,3.242A28.854,28.854,0,0,1,28.075,9.663a1.185,1.185,0,1,1,1.286,1.99ZM27.238,25.461a2.368,2.368,0,0,1-2.368,2.368H13.027a2.368,2.368,0,0,1-2.368-2.368V13.619a2.368,2.368,0,0,1,2.368-2.368h11.1a28.972,28.972,0,0,0-2.3,2.368H13.027V25.461H24.869V17.371a24.93,24.93,0,0,1,2.368-2.551ZM18.948,0A18.948,18.948,0,1,0,37.9,18.948,18.948,18.948,0,0,0,18.948,0Z",
    transform: "translate(186 704)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedClass);
export default __webpack_public_path__ + "static/media/CompletedClass.280d00fc1c4c3e710d17743763ed4ba3.svg";
export { ForwardRef as ReactComponent };